export const USER_BASE_PATH = '/users';

export const userPaths = {
  base: USER_BASE_PATH,
  dashboard: `${USER_BASE_PATH}/dashboard`,
  /** Legacy referral entry; redirects to ftue with query params preserved. */
  landing: `${USER_BASE_PATH}/landing`,
  ftue: `${USER_BASE_PATH}/ftue`,
  terms: `${USER_BASE_PATH}/terms`,
  linkExpired: `${USER_BASE_PATH}/link-expired`,
  endUser: `${USER_BASE_PATH}/end-user`,
  expenseCertification: `${USER_BASE_PATH}/expense-certification`,
  confirmCashback: `${USER_BASE_PATH}/confirm-cashback`,
  cashOut: `${USER_BASE_PATH}/cash-out`,
  approvePayout: `${USER_BASE_PATH}/approve-payout`,
  payoutSetup: `${USER_BASE_PATH}/payout-setup`,
  payoutSetupConnectAccount: `${USER_BASE_PATH}/payout-setup/connect-payout-account`,
  payoutSetupConnectAccountKyc: `${USER_BASE_PATH}/payout-setup/connect-payout-account/kyc`,
  payoutSetupConnectAccountKycFailed: `${USER_BASE_PATH}/payout-setup/connect-payout-account/kyc/failed`,
  payoutSetupConfirmHsaAccount: `${USER_BASE_PATH}/payout-setup/confirm-hsa-account`,
  payoutSetupAchAuthorization: `${USER_BASE_PATH}/payout-setup/ach-authorization`,
  payoutSetupPayrollDeductionAuth: `${USER_BASE_PATH}/payout-setup/payroll-deduction-auth`,
  hsaPaydays: `${USER_BASE_PATH}/hsa-paydays`,
  hsaSuccess: `${USER_BASE_PATH}/hsa-success`,
  expenses: `${USER_BASE_PATH}/expenses`,
  noExpensesRemaining: `${USER_BASE_PATH}/no-expenses-remaining`,
  noExpenseFound: `${USER_BASE_PATH}/no-expense-found`,
  myAccount: `${USER_BASE_PATH}/my-account`,
  myAccountUpdateProfile: `${USER_BASE_PATH}/my-account/update-profile`,
  myAccountHsaDetails: `${USER_BASE_PATH}/my-account/hsa-details`,
  myAccountHealthAccounts: `${USER_BASE_PATH}/my-account/health-accounts`,
  finchConnection: `${USER_BASE_PATH}/finch-connection`,
  piiVerification: `${USER_BASE_PATH}/pii-verification`,
  signIn: `${USER_BASE_PATH}/sign-in`,
  signInPhone: `${USER_BASE_PATH}/sign-in/phone`,
  signInOtp: `${USER_BASE_PATH}/sign-in/otp`,
  onboarding: `${USER_BASE_PATH}/onboarding`,
  onboardingEmailVerification: `${USER_BASE_PATH}/onboarding/email-verification`,
  onboardingPhoneVerification: `${USER_BASE_PATH}/onboarding/phone-verification`,
  onboardingOtpVerification: `${USER_BASE_PATH}/onboarding/otp-verification`,
  onboardingCompleteProfile: `${USER_BASE_PATH}/onboarding/complete-profile`,
  onboardingPersonalDetails: `${USER_BASE_PATH}/onboarding/personal-details`,
  onboardingFindExpenses: `${USER_BASE_PATH}/onboarding/find-expenses`,
  onboardingFindExpensesSuccess: `${USER_BASE_PATH}/onboarding/find-expenses/success`,
  onboardingFindExpensesProviders: `${USER_BASE_PATH}/onboarding/find-expenses/providers`,
} as const;

export const userPathWithProvider = (providerId: string): string =>
  `${userPaths.onboardingFindExpensesProviders}/${providerId}`;
